import React, { useEffect, useState } from 'react'
import Rating from '@mui/material/Rating'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { Typography, Button, Container } from '@material-ui/core'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import prepareRating from './preperation/rating'
import { predictWithCFUserBased } from './collaborative/collaborative'

const Rekomendasi = ({onAddFavorite, onDetail, dataUser, refRekomendasi}) => {

  const [rat, setRat] = useState([])
  const [wisataRekomendasi, setWisataRekomendasi] = useState([])
  const [favorite, setFavorite] = useState(false);

  const getWisata = async () => {
    const respon = await axios.get(`https://rekomend.herokuapp.com/getRating`)
    const wis = await axios.get(`https://rekomend.herokuapp.com/admin/getDataWisata`)
    const data = wis.data.data;
    const ratings = respon.data.data
    setRat(ratings)
    const USER_ID = localStorage.getItem("userId");
    const { ratingsGroupedByUser, ratingsGroupedByAttraction } =
    prepareRating(ratings);
    const recommendedCFUserBased = predictWithCFUserBased(
      ratingsGroupedByUser,
      ratingsGroupedByAttraction,
      USER_ID,
      ratings
    );
    const recomend = recommendedCFUserBased.filter(reko => reko.score >= 0.8 )
    const i = recomend.map(dat => dat.attractionId.aid)
    const c = data.filter(dat => i.includes(dat._id))  
    // const wisata = recomend.map(re => re.attractionId.wisataDetail[0])
    setWisataRekomendasi(c)
  }

  const Length = (aid) => {
    const a = rat.filter(ra => aid.includes(ra.aid))
    const leng = a.length
    return leng
  }

  useEffect(() => {
    getWisata()
  }, [])

  return (
    <main ref={refRekomendasi}>
    <Container>
    <div className='pb-12 mb-20'>
    <Typography style={{fontWeight: 'bold', display: 'flex', flexDirection: 'column'}} variant='h3'>Destinasi <span>Rekomendasi</span></Typography>
      <Typography variant='subtitle1'>Bingung mencari destinasi?<br/>coba destinasi yang kami Rekomendasikan</Typography>
        {wisataRekomendasi.length === 0 &&(
          <div className='bg-blue-400 m-20 p-6 rounded-md'>
          <Typography style={{fontWeight: 'bold'}} variant='h6'>Info</Typography>
          <Typography variant='subtitle1'>Kasih Ulasan agar anda Mendapatkan Rekomendasi wisata, <Link style={{textDecoration: 'underline', color: 'green'}} to="/all-destinasi">cari wisata</Link></Typography>
          </div>
        )}
        <div className='md:px-0 grid sm:grid-cols-2 gap-12 md:grid-cols-3 lg:grid-cols-4 px-8 mt-8'>
        {
        wisataRekomendasi.lengt != 0 && (
          wisataRekomendasi.map(datas=>(
          <div className='relative h-[340px] w-full'>
                <LazyLoadImage className=' w-full h-[80%] rounded-md scale-100 hover:scale-[1.05] hover:ease-in-out hover:duration-700 duration-700' height='80%' width='100%' effect='blur' src={`https://rekomend.herokuapp.com/admin/getSingleImage/${datas.gambar}`} alt='wisata'/>
                <div className='cursor-pointer opacity-80 absolute top-4 right-4 bg-slate-50 rounded-md px-3 py-2'>
                  {
                    favorite? <span className='text-xl text-red-600'><ion-icon onClick={()=> setFavorite(!favorite)} name="heart"/></span> : <span className='text-xl hover:text-red-600' onClick={() => onAddFavorite(datas._id)}><ion-icon onClick={()=> setFavorite(!favorite)} name="heart"/></span>
                  }
                </div>
                <div className='bg-white absolute bottom-0 left-[18px] rounded-xl w-[88%] p-4 shadow-md flex flex-col items-center'>
                    <h2 className='text-2xl'>{datas.wisata}</h2>
                    {/* <p className='text-sm text-gray-500'>Anim veniam sit nulla reprehenderit veniam officia dolore ut velit occaecat velit voluptate ad est.</p> */}
                    <span className='flex items-center'>
                      <Rating
                        readOnly
                        name="Rating Label"
                        value={datas.totalRating}
                        precision={0.5}
                        // onChange={(event, newValue) => {
                        //   setRatingValue(newValue);
                        // }}
                      />
                      <p className='ml-2 text-xl font-semibold'>{datas.totalRating === 1 ||datas.totalRating === 2 || datas.totalRating === 3 || datas.totalRating === 4 || datas.totalRating === 5 ? `${datas.totalRating}.0`: datas.totalRating}</p>
                    </span>
                    <p className='text-gray-500 mb-3'>({Length(datas._id)} Review)</p>
                    <Button fullWidth onClick={() => onDetail(datas._id, dataUser)} component={Link} to="/detail" variant='contained' color='primary'>Detail</Button>
                </div>
            </div>
        )
        ))}
        </div>
    </div>
    </Container>
    </main>
  )
}

export default Rekomendasi